import React from 'react';
import { EventType, Reason, Status } from '../../graphql/graphql';
import { MetadataMessage } from './MetadataMessage';
import { HorizontalRule } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { log } from '../../lib/logger';
import { useTranslation } from 'react-i18next';
import { WelcomeMessageController } from '../../controllers/WelcomeMessageController';
export const NewCaseSeparator = styled(HorizontalRule) `
  margin-top: 2rem;
  width: 100%;
  border-block-start: 1px solid #dedede;
`;
export const isStatusEvent = (event) => {
    return (event.type === EventType.SupportCaseStatus &&
        event.supportCaseStatusEvent !== null);
};
export const StatusMessage = ({ event, isFirstOpenEvent = false, onOptionClick, }) => {
    const { t } = useTranslation();
    const isRestartEvent = event.supportCaseStatusEvent.reason === Reason.Restarted;
    switch (event.supportCaseStatusEvent.status) {
        case Status.Closed:
            return (React.createElement(MetadataMessage, { text: t('END_OF_CONVERSATION_CLOSE_WINDOW_TEXT') }));
        case Status.PostSurvey:
            return React.createElement(MetadataMessage, { text: t('CONVERSATION_CLOSED_TEXT') });
        case Status.Open:
            return (React.createElement(React.Fragment, null,
                !isFirstOpenEvent ? React.createElement(NewCaseSeparator, null) : null,
                !isRestartEvent ? (React.createElement(WelcomeMessageController, { event: event, onOptionClick: onOptionClick })) : null));
        default:
            log.warn('Unimplemented Status Message type', event);
            return null;
    }
};
